// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"362":"Dashboard","438":"Login","494":"Register","613":"ChatLogic"}[chunkId] || chunkId) + "." + {"16":"7a3a9c5a","303":"0720e442","362":"802e64cd","437":"711e5bd6","438":"2b3548d6","494":"598dfbea","613":"c8f0da48"}[chunkId] + ".js";
};